import { render } from "./ViewTraining.vue?vue&type=template&id=ac1f6342&scoped=true"
import script from "./ViewTraining.vue?vue&type=script&lang=js"
export * from "./ViewTraining.vue?vue&type=script&lang=js"

import "./ViewTraining.vue?vue&type=style&index=0&id=ac1f6342&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1f6342"]])

export default __exports__